<template>
  <material-card
    class="card-tabs"
    color="green"
    title="Recent Transactions"
    style="margin-top: 0px;"
  >
    <v-data-table
      :headers="headers"
      :items="transactions.items"
      :loading="transactions.loading"
      :options.sync="transactions.options"
      @update:options="updateOpt"
      :server-items-length="transactions.total"
      :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
      :items-per-page="15"
      sort-by="created"
      sort-desc
      height="530"
      fixed-header
      class="user-recent-transaction-dt"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:item.comment="{ item }">
        <div style="max-width: 400px;">
          {{ item.comment }}
        </div>
      </template>
    </v-data-table>
  </material-card>
</template>

<style>
  .user-recent-transaction-dt td {
    vertical-align: text-top;
    padding: 12px 6px!important;
  }
</style>
<script>

  import { mapGetters } from 'vuex'

  export default {

    props: [],

    data: () => ({
      headers: [
        { text: 'Created', value: 'created' },
        { text: 'Finished', value: 'completed' },
        { text: 'ID', value: 'account_transaction_id', sortable: true },
        { text: 'Description', align: 'left', sortable: false, value: 'comment' },
        { text: 'Debit/Credit', value: 'amount', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Paymethod', value: 'paymethod', sortable: false },
        { text: 'Paysystem', value: 'paysystem', sortable: false },
      ],
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', transactions: 'account/recentTransactions' }),
    },

    mounted () {
      // this.$store.dispatch('account/loadRecentTransactions', this.activeAccount.account).catch(e => {
      //   this.$notification.show = true
      //   this.$notification.message = e.response.data.message
      //   this.$notification.type = 'error'
      // })
    },

    watch: {
      // 'transactions.options' (newOpt, oldOpt) {
      //
      //   console.log(JSON.stringify(newOpt))
      //   console.log(JSON.stringify(this.transactions.options))
      //   console.log(JSON.stringify(oldOpt))
      //   if (!_.isEqual(newOpt, this.transactions.options)) {
      //     this.$store.dispatch('account/loadRecentTransactions', this.activeAccount.account).catch(e => {
      //       this.$notification.show = true
      //       this.$notification.message = e.response.data.message
      //       this.$notification.type = 'error'
      //     })
      //   }
      // }
    },
    methods: {
      updateOpt (val) {
        if (this.transactions.toUpdateOpt) {
          this.$store.dispatch('account/loadRecentTransactions', this.activeAccount.account).catch(e => {
            this.$notification.show = true
            this.$notification.message = e.response.data.message
            this.$notification.type = 'error'
          })
        } else {
          this.transactions.toUpdateOpt = !this.transactions.toUpdateOpt
        }
      }
    },
  }
</script>
